import PageWrapper from 'components/utils/PageWrapper';
import Book from 'pages/Book';

export const bookRoutes = {
    path: '/book',
    element: (
        <PageWrapper titleId="common_book">
            <Book />
        </PageWrapper>
    ),
};
